module.exports = __webpack_public_path__ + "img/img2.474985e8.jpg";